import { CollectionResponse } from "../../models/responses/CollectionResponse";
import * as types from "../actions/collectionActions";

interface CollectionState {
    collections: CollectionResponse[];
    selectedCollection: CollectionResponse | null;
    error: string | null;
    isLoading: boolean;
    operationLoading: boolean;
    systemCollectionId: number | null;
}

const initialState: CollectionState = {
    collections: [],
    selectedCollection: null,
    error: null,
    isLoading: false,
    operationLoading: false,
    systemCollectionId: null
}

export const collectionReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case types.LOAD_COLLECTIONS_SUCCESS:
            return {
                ...state,
                collections: action.payload,
                isLoading: false,
                error: null
            }
        case types.LOAD_COLLECTIONS_ERROR:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        case types.SET_SELECTED_COLLECTION:
            return {
                ...state,
                selectedCollection: action.payload
            }
        case types.SET_SYSTEM_COLLECTION_ID:
            return {
                ...state,
                systemCollectionId: action.payload
            }
        case types.COLLECTION_OPERATION_LOADING:
            return {
                ...state,
                operationLoading: action.payload,
                error: null
            }
        case types.ADD_COLLECTION_SUCCESS:
        case types.UPDATE_COLLECTION_SUCCESS:
        case types.DELETE_COLLECTION_SUCCESS:
            return {
                ...state,
                operationLoading: false,
                error: null
            }
        case types.ADD_COLLECTION_ERROR:
        case types.UPDATE_COLLECTION_ERROR:
        case types.DELETE_COLLECTION_ERROR:
            return {
                ...state,
                operationLoading: false,
                error: action.payload
            }
        default:
            return state;
    }
}